import styled from 'styled-components'

// Icons
import { ReactComponent as CheckmarkIcon } from 'icons/check-12.svg'
import { ReactComponent as ExclamationIcon } from 'icons/exclamation-mark-circle-11.svg'

// Components
import Button from 'components/Button'
import Link from 'components/Link'

// Types
import { InitialUserFragment } from 'gqlTypes'

type StatusType = {
  status: InitialUserFragment['mfaState']
}

export const Checkmark = styled(CheckmarkIcon)`
  position: absolute;
  left: -24px;
  width: 16px;
  height: 16px;
`

export const Exclamation = styled(ExclamationIcon)`
  position: absolute;
  left: -24px;
  width: 16px;
  height: 16px;
`

export const StatusList = styled.ul`
  margin-top: 24px;
  list-style: none;
  padding-left: 24px;
`

export const Status = styled.li<StatusType>`
  position: relative;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.small};

  ${({ theme, status }) => {
    if (status === 'ENABLED') {
      return `color: ${theme.colors.state.positive};`
    }

    if (status === 'PENDING_DISABLE') {
      return `
        color: ${theme.colors.state.negative};
        font-weight: ${theme.fontWeights.medium};
      `
    }
  }}
`

export const StyledButton = styled(Button)`
  margin-left: 16px;
`

export const StyledLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes.small};
`
